const pickMainVariation = ({ variations = [] }) => {
  let firstSalableVariation = null

  variations.some(variation => {
    if (variation.availableForSale) {
      firstSalableVariation = variation
      return true
    }
    return false
  })

  return firstSalableVariation || variations[0] || null
}

export {
  pickMainVariation
}